import React, { useEffect, useState, useCallback } from "react";
import {
  NotiContainer,
  NotiCard,
  NotiTitle,
  NotiDes,
  NotiDate,
  SpinWrapper,
  NotiCardContainer,
  NotiTime,
  Image,
  NotiTimeContainer,
  NotiNew,
} from "./Notification.style";
import { message, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import PocketMoneyModal from "./PocketMoneyModal/PocketMoneyModal";
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { getFingerprintData } from "@utils";
import { CHANNEL_SK } from "@constants";
import { LIMITS, MESSAGE_TYPES } from "@constants";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import { CalendarFilled } from "@assets";
import {
  CalendarModal,
  BottomNavigator,
  Topbar,
  EmptyCard,
  Spin as SpinWheel,
  Alert,
} from "@components";
import { useTranslation } from "react-i18next";
import { setOpenLoginAlert } from "@redux/auth/authSlice";
import { openAlert } from "@redux/app/appSlice";
import { useDispatch, useSelector } from "react-redux";

const { DEFAULT_PAGE } = LIMITS;
const { NOTIFICATION, POCKET_MONEY, SPIN } = MESSAGE_TYPES;

const apiDateFormat = "YYYY-MM-DD";

const NotiComponent = ({ noti, onClick, isDate }) => {
  const { t } = useTranslation();
  const { images, title, content, sent_at, type, read } = noti;

  return (
    <NotiCardContainer>
      {isDate && (
        <NotiDate>{moment.unix(sent_at).format("D MMMM YYYY")}</NotiDate>
      )}
      <NotiCard onClick={onClick}>
        {images && images.map((image, key) => <Image key={key} src={image} />)}
        <NotiTitle>{title}</NotiTitle>
        {type !== NOTIFICATION && <NotiDes>{content}</NotiDes>}
        <NotiTimeContainer>
          <NotiTime>{moment.unix(sent_at).format("D MMMM, YYYY, LT")}</NotiTime>
          {!read && <NotiNew>{t("common.new")}</NotiNew>}
        </NotiTimeContainer>
      </NotiCard>
    </NotiCardContainer>
  );
};

const Notification = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpenCalendar, setIsOpenCalendar] = useState(false);
  const [isOpenPocket, setIsOpenPocket] = useState(false);
  const [loading, setLoading] = useState(true);
  const [roomId, setRoomId] = useState(null);
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [date, setDate] = useState(null);
  const [selectedNoti, setSelectedNoti] = useState(null);
  const isLoggedIn = useSelector((state) => state.auth.token);
	const has_withdraw_account = useSelector(state => state.app.has_withdraw_account);

  useEffect(() => {
    getFingerprintData()
      .then(device_info => {
        getNotifications(device_info);
      })
      .catch(() => { });

    // eslint-disable-next-line
  }, []);

  const getMessages = useCallback((device_info) => {
    let postData = {
      page,
      limit: 20,
      room_id: roomId,
      device_info,
    };
    if (date) {
      postData = {
        ...postData,
        start_date: date,
        end_date: date,
      };
    }
    setLoading(true);
    api
      .getMessages(postData)
      .then(({ messages, pagination }) => {
        setLoading(false);
        setTotal(pagination.total);
        if (page === 1) {
          setData(messages.reverse());
        } else {
          setData((prev) => [...prev, ...messages.reverse()]);
        }
      })
      .catch((errorMsg) => {
        message.error(errorMsg);
      });
  }, [page, roomId, date]);

  useEffect(() => {
    if (roomId) {
      getFingerprintData()
        .then(device_info => {
          getMessages(device_info);
        })
        .catch(() => { });
    }
  }, [getMessages, roomId]);

  const getNotifications = (device_info) => {
    setLoading(true);
    api
      .getRooms({
        device_info,
      })
      .then(({ rooms }) => {
        let room_id = rooms.filter((item) => item.type === CHANNEL_SK)[0]
          .room_id;
        setRoomId(room_id);
      })
      .catch((errorMsg) => {
        message.error(errorMsg);
      });
  };

  const onOk = (newdate) => {
    newdate = newdate.format(apiDateFormat);
    if (newdate !== date) {
      setDate(newdate);
      setPage(DEFAULT_PAGE);
      setData([]);
      setTotal(0);
    }
    handleClose();
  };

  const onReset = () => {
    if (date) {
      setDate("");
      setPage(DEFAULT_PAGE);
      setData([]);
      setTotal(0);
    }
  };

  const handleClose = () => {
    setIsOpenCalendar(false);
  };

  const goBack = () => {
    navigate(-1);
  };

  const handleNavigate = (type, state) => {
    getFingerprintData()
      .then(device_info => {
        api
          .postReadMessage({
            message_id: state.message_id,
            device_info,
          })
          .then(() => {
            if (type === NOTIFICATION) {
              navigate(`/${PUBLIC_ROUTE.NOTIFICATION_DETAILS}`, {
                state,
              });
            } else if (type === POCKET_MONEY) {
              if (!isLoggedIn) {
                dispatch(setOpenLoginAlert(true));
                return;
              }
              if (!has_withdraw_account) {
                dispatch(
                  openAlert({
                    isError: true,
                    message: t("common.withdrawAccountNeededErrorMsg"),
                    successCallback: () => navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`, { state: { isNoti: 1 } }),
                  })
                );
                return;
              }
              setIsOpenPocket(true);
            } else if (type === SPIN) {
              navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
            } else {
              return;
            }
          })
          .catch((errorMsg) => {
            message.error(errorMsg);
          });
      })
      .catch(() => { });
  };

  return (
    <>
      <NotiContainer>
        <Topbar
          title={t("notification.notificationTitle")}
          rightIcon={
            <CalendarFilled
              style={{ marginTop: "8px" }}
              onClick={() => setIsOpenCalendar(true)}
            />
          }
          showLeftIcon={false}
          goBack={goBack}
        />

        <InfiniteScroll
          dataLength={data.length}
          next={() => {
            setPage((prev) => prev + 1);
          }}
          hasMore={loading || data.length !== total}
          loader={
            <SpinWrapper>
              <Spin size="small" />
            </SpinWrapper>
          }
          endMessage={
            !loading && data.length === 0 && <EmptyCard minHeight={160} />
          }
        >
          {data.map((noti, index) => (
            <NotiComponent
              isDate={
                index === 0 ||
                moment.unix(noti.sent_at).date() !==
                moment.unix(data[index - 1].sent_at).date()
              }
              key={index}
              noti={noti}
              onClick={() => {
                handleNavigate(noti.type, noti);
                setSelectedNoti(noti);
              }}
            />
          ))}
        </InfiniteScroll>
      </NotiContainer>
      <CalendarModal
        open={isOpenCalendar}
        date={date}
        onOk={onOk}
        onReset={onReset}
        handleClose={handleClose}
      />
      <PocketMoneyModal
        isOpen={isOpenPocket}
        setIsOpen={() => setIsOpenPocket(false)}
        pocket_money_id={selectedNoti?.pocket_money_id}
      />
      <BottomNavigator isNoti={true} />
      <SpinWheel />
      <Alert />
    </>
  );
};

export default Notification;
